/*
  COMPONENT: Cello Product Template
  PURPOSE: Dynamically creates cello product pages from GraphQL data
*/

import React, { useContext, useEffect } from 'react'
import { graphql, navigate } from 'gatsby'

// components
import Layout from '../../components/Layout'
import ProductPage from '../../components/ProductPage'
import InterestForm from '../../components/InterestForm'
import CelloArtists from '../../components/CelloArtists'
import { UserContext } from '../../providers/UserProvider'

// view
const Product = ({ location, data }) => {
  const { customerRegion } = useContext(UserContext)
  const product = data.cosmicjsCellos
  const displayRegions = product.metadata?.display_regions

  // only run this check client side (i.e. not on site build)
  useEffect(() => {
    if (customerRegion && displayRegions?.length) {
      if (
        !displayRegions.some(
          (displayRegion) => displayRegion.slug === customerRegion,
        )
      ) {
        console.debug(
          `display regions exist on product, but user isn't in a valid one - redirect to category page`,
        )

        navigate(`/cello`, { replace: true })
      }
    }
  }, [customerRegion, displayRegions])

  return (
    <Layout location={location} product={product}>
      <ProductPage product={product} category="cello" />

      <CelloArtists />

      <InterestForm
        interest={`${product.metadata.product_name} ${product.title}`}
        formStyle="dark"
      />
    </Layout>
  )
}

export default Product

export const Head = ({ data }) => {
  const product = data.cosmicjsCellos

  return (
    <>
      <html lang="en-US" />
      <title>{`Eastman - Cello - ${product.title}`}</title>
      <meta name="description" content={product.metadata.product_description} />
      {product.metadata.hide_from_search && (
        <meta name="robots" content="noindex" />
      )}
    </>
  )
}

// data
export const query = graphql`
  query ($id: String!) {
    cosmicjsCellos(id: { eq: $id }) {
      id
      type
      slug
      title
      metadata {
        display_regions {
          slug
        }
        hide_from_search
        product_callout
        product_name
        product_description
        playing_level {
          key
          value
        }
        product_image_front {
          url
          imgix_url
        }
        product_image_back {
          url
          imgix_url
        }
        cta {
          link_text
          page_to_link {
            id
            slug
            metadata {
              path
            }
          }
          external_link
          path_to_link
        }
        product_specs {
          finish {
            key
            value
          }
          fingerboard {
            key
            value
          }
          top {
            key
            value
          }
          ribs {
            key
            value
          }
          back {
            key
            value
          }
          purfling {
            key
            value
          }
          bridge {
            key
            value
          }
          fittings {
            key
            value
          }
          electronics
          available_patterns
          available_sizes
        }
      }
    }
  }
`
